<div class="dialog-container">
  <div class="inputs-holder no-padding">
    <mat-form-field appearance="fill" class="new-input-field">
      <mat-icon matPrefix>search</mat-icon>
      <input
        placeholder="{{ 'SHARED.DIALOGS.ADD_PEOPLE_DIALOG.SEARCH_FOR_EMPLOYEE' | translate }}"
        [(ngModel)]="filter"
        autocomplete="off"
        matInput
      />
      @if (!this.selectedEmployees.length) {
        <mat-icon matSuffix class="close-dialog-btn" (click)="closeDialog()">close </mat-icon>
      }
    </mat-form-field>
    @if (!data.hideSelectAll) {
      <mat-checkbox
        (change)="handleSelectAllClick()"
        [checked]="listOfAllEmployees.length === selectedEmployees.length"
        class="select-all-button"
      >
        {{ 'SHARED.SELECT_ALL' | translate }}
      </mat-checkbox>
    }
  </div>
  <mat-dialog-content>
    <div class="flex-columns">
      @if (listOfAllEmployees.length > 0) {
        @for (
          employee of listOfAllEmployees | filter: filter : 'fullName';
          track employee;
          let index = $index;
          let last = $last
        ) {
          <div>
            <mat-checkbox
              (change)="removeOrAddEmployee(employee)"
              [checked]="employeeNames.includes(employee.fullName)"
            >
              <app-employee-card [employee]="employee" />
            </mat-checkbox>
            @if (!last) {
              <mat-divider></mat-divider>
            }
          </div>
        }
      } @else {
        <div class="no-employees-message">
          {{ 'SHARED.DIALOGS.ADD_PEOPLE_DIALOG.NO_EMPLOYEES' | translate }}
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="add-people-button-holder">
    @if (this.selectedEmployees.length) {
      <button mat-raised-button color="primary" class="full-width" (click)="closeDialog()">
        <mat-icon>add</mat-icon>
        <span>{{ 'SHARED.DIALOGS.ADD_PEOPLE_DIALOG.ADD_PEOPLE' | translate }}</span>
      </button>
    }
  </mat-dialog-actions>
</div>
